import React from 'react';
import { StatBanner, type Stat } from './StatBanner';
import { TimeScope } from './TimeScope';
import type { ScopeValue, WindowCounts } from '../utils/timeWindow';

// Global page header shared by the table pages. The time scope ("Period") is the
// primary header — it reads first because the stats below are scoped by it. Both
// sit on a recessed wash band, distinct from the working content (tabs / filters
// / table) underneath.
interface PageHeaderProps {
  stats?: Stat[];
  scope: ScopeValue;
  onScopeChange: (v: ScopeValue) => void;
  counts: WindowCounts;
}

export function PageHeader({ stats, scope, onScopeChange, counts }: PageHeaderProps) {
  return (
    <div className="bg-tint border-b border-trim px-6 py-3 flex-shrink-0">
      {/* Single sleek row: period anchored left, scoped stats anchored right —
          the two ends balance the full-width band so there's no empty middle.
          When a page passes no stats, the period control stands alone. */}
      <div className="flex items-center justify-between gap-4 flex-wrap gap-y-2">
        {/* Period — primary scope control */}
        <div className="flex items-center gap-3">
          <span className="text-xs font-semibold uppercase tracking-wide text-ink">Period</span>
          <TimeScope value={scope} onChange={onScopeChange} counts={counts} />
        </div>
        {/* Stats — scoped by the period */}
        {stats && stats.length > 0 && <StatBanner stats={stats} />}
      </div>
    </div>
  );
}
